import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { Modules } from '@app/core/Enum';
import {
  MainListComponent,
  ReportListWithActionsComponent,
} from '@app/modules/common';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-fixed-assest-dispose-active',
  templateUrl: './fixed-assest-dispose-active.component.html',
  styleUrls: ['./fixed-assest-dispose-active.component.scss'],
})
export class FixedAssestDisposeActiveComponent implements OnInit {
  selectedTab = 0;
  modulesEnum = Modules;
  @ViewChild(ReportListWithActionsComponent, { static: true })
  reportListWithActions;
  isExpandAll = false;
  @ViewChild(MatAccordion) accordion: MatAccordion;
 triggerModuleId: BehaviorSubject<any> = new BehaviorSubject<any>(
    Modules.ActiveTangibleFixedAssets
  );
  selectedModuleId = Modules.ActiveTangibleFixedAssets;
  toggleAccordion(): void {
    this.isExpandAll = !this.isExpandAll;
  }
  
  ngOnInit(): void {
    this.onTabClick(this.selectedTab);
  }

  onTabClick(event: any): void {
    this.selectedTab = event;
    // if (this.selectedTab === 0) {
    //   this.reportListWithActions.moduleId = Modules.FixedAssetsRegister;
    //   this.reportListWithActions.getList(false);
    // }
    if (this.selectedTab === 0) {
      this.selectedModuleId = Modules.ActiveTangibleFixedAssets;
      this.triggerModuleId.next(Modules.ActiveTangibleFixedAssets);
    } else {
      this.selectedModuleId = Modules.DisposeTangibleFixedAssets;
      this.triggerModuleId.next(Modules.DisposeTangibleFixedAssets);
    }
  }  
   onAccordionClick(moduleId: number): void {
    this.selectedModuleId = moduleId;
    if (this.selectedTab === 0) {
      this.triggerModuleId.next(this.selectedModuleId);
    }
  }
}
